
 import { useParams } from 'react-router-dom';
import EditAgencyOfficials from './EditAgencyOfficials';

function EditAgencyOfficialsPage() {
   const { official_id:id} = useParams();
    return ( 
        <div className="container-fluid">
            <EditAgencyOfficials official_id={id}/>
        </div>
     );
}

export default EditAgencyOfficialsPage;
